import ANCHOR, { SPAN } from '../../../DOM/a/anchor/ANCHOR.js';
import EL from '../../../EL/EL.js';
import { LISTITEMELEMENT } from '../../../../enums/LISTITEMELEMENT.js';
/** An abstract List Item Constructor */
export default class ITEM extends EL {
    constructor(node, element = LISTITEMELEMENT.LI, model) {
        super(node, element, model);
        this.addClass('item');
        if (model.data.text) {
            this.setInnerHTML(model.data.text);
        }
    }
    /** Adds an ANCHOR to this ITEM */
    addAnchor(model) {
        return this.addChild(new ANCHOR(this, model));
    }
    /** Adds a SPAN to this ITEM */
    addSpan(model) {
        return this.addChild(new SPAN(this, model));
    }
}
export { ANCHOR, EL, SPAN };
